import { User } from "../generated/graphql";

const getUserFullName = ({ firstName, lastName }: User) =>
  `${firstName ?? ""} ${lastName ?? ""}`;

export default getUserFullName;
